import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Big from 'UIComponents/elements/Big';
import UISection from 'UIComponents/section/UISection';
import MainSection from 'marketplace-ui-common/layout/components/MainSection';
import MainSectionInner from 'marketplace-ui-common/layout/components/MainSectionInner';
import StorefrontSection from 'marketplace-ui-common/storefront/components/StorefrontSection';
//@ts-expect-error untyped dependency
import { getFeaturedAppsUrl } from '../../utils/urls';
import AppCollectionsCardGrid from './AppCollectionsCardGrid';
import { jsx as _jsx } from "react/jsx-runtime";
export default function AppCollectionsResultsSection({
  className,
  trackInteraction
}) {
  return /*#__PURE__*/_jsx(MainSection, {
    className: className,
    color: "light",
    children: /*#__PURE__*/_jsx(MainSectionInner, {
      children: /*#__PURE__*/_jsx(StorefrontSection, {
        primaryGridSize: 9,
        subtitle: /*#__PURE__*/_jsx("p", {
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(Big, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "appMarketplace.storefront.results.collections.collectionsSubtitle"
            })
          })
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "appMarketplace.storefront.results.collections.collectionsTitle"
        }),
        titleControls: /*#__PURE__*/_jsx(UIRouterLink, {
          onClick: () => trackInteraction('click featured apps link'),
          to: getFeaturedAppsUrl(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "appMarketplace.storefront.results.collections.collectionsLink"
          })
        }),
        titleControlsMobile: "md",
        children: /*#__PURE__*/_jsx(UISection, {
          use: "island",
          children: /*#__PURE__*/_jsx(AppCollectionsCardGrid, {})
        })
      })
    })
  });
}